import React from 'react';
import {inject, observer} from 'mobx-react';
import {toJS} from 'mobx';
import {WeaNewScroll} from 'ecCom';

import './style/pt-menu.less';
import Menu, {SubMenu, Item as MenuItem} from '../../../../../../pc4public/portal/_rc/_rc-menu-7.0.3/src';

@inject("portalThemeStore")
@observer
class E9LeftMenu extends React.Component {
    constructor(props) {
        super(props);
        this.getLeftMenu = this.getLeftMenu.bind(this);
        this.onTitleClick = this.onTitleClick.bind(this);
        this.onSelect = this.onSelect.bind(this);
    }

    render() {
        const {portalThemeStore} = this.props;
        const {themeInfo, frontEndMenu = [], leftMenuObj} = portalThemeStore;
        const {themeData = {}} = themeInfo;
        const {styleConfig = {}} = themeData;
        const {leftmenu = {}} = styleConfig;
        const fontSize = parseInt(leftmenu.titleFontSize || '12px');
        const {leftMenuSelected = {}} = leftMenuObj;
        const _frontEndMenu = toJS(frontEndMenu);
        const _leftMenuSelected = toJS(leftMenuSelected);
        const _selectedKeys = [_leftMenuSelected.id || ''];

        return (
            <div className={`e9left-container wea-f${fontSize}`}>
                <WeaNewScroll height="100%">
                    <Menu
                        mode="vertical"
                        prefixCls="pt-menu"
                        openAnimation="zoom"
                        subMenuCloseDelay={0.2}
                        selectedKeys={_selectedKeys}
                        onClick={this.onSelect}
                    >
                        {this.getLeftMenu(_frontEndMenu, 1, fontSize)}
                    </Menu>
                </WeaNewScroll>
            </div>
        );
    }

    getLeftMenu(data, level, fontSize) {
        return data.map((item) => {
            if (item.child && item.child.length) {
                return (
                    <SubMenu
                        key={item.id}
                        popupClassName={`e9left-sub-container wea-f${fontSize}`}
                        title={
                            level == 1 ? (
                                    <span className="e9aside-top-menu-icon">
                                        {item.icon ? <i className={item.icon}/> : <i className={`wevicon-top-menu-default wevicon-top-menu-${item.infoId || 0}`}/>}
                                        <span>{item.name}</span>
                                    </span>
                                ) : (
                                    <span>{item.name}</span>
                                )
                        }
                        data={item}
                        onTitleClick={() => this.onTitleClick(item)}
                    >
                        {this.getLeftMenu(item.child, level + 1, fontSize)}
                    </SubMenu>
                );
            } else {
                return (
                    <MenuItem key={item.id} data={item}>
                        {
                            level == 1 ? (
                                    <div className="pt-menu-item-title">
                                        <span className="e9aside-top-menu-icon">
                                            {item.icon ? <i className={item.icon}/> : <i className={`wevicon-top-menu-default wevicon-top-menu-${item.infoId || 0}`}/>}
                                            <span>{item.name}</span>
                                        </span>
                                    </div>
                                ) : (
                                    <span>{item.name}</span>
                                )
                        }
                    </MenuItem>
                );
            }
        });
    }

    onTitleClick(data) {
        const {portalThemeStore} = this.props;

        if (data.mobxrouteurl || data.fullrouteurl || (data.url && data.url != 'javascript:void(0);')) {
            portalThemeStore.onLeftMenuSelectedChange(data);
            portalThemeStore.onLoadMain(data);
        } else if (data.child && data.child.length) {
            let item = data.child[0];
            for (; ;) {
                if (item.mobxrouteurl || item.fullrouteurl || (item.url && item.url != 'javascript:void(0);')) {
                    portalThemeStore.onLeftMenuSelectedChange(item);
                    portalThemeStore.onLoadMain(item);
                    break;
                } else if (item.child && item.child.length) {
                    item = item.child[0];
                } else {
                    break;
                }
            }
        }
    }

    onSelect(e) {
        const {data} = e.item.props;
        const {portalThemeStore} = this.props;
        portalThemeStore.onLeftMenuSelectedChange(data);
        portalThemeStore.onLoadMain(data);
    }
}

export default E9LeftMenu;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology9/layout3/E9LeftMenu.js